



































































































import {
  BibliographyDetailVolumeTable,
  BibliographyDetailVolumeTableItem,
  BibliographyDetailVolumeTableItemRow
} from '@/components/organisms/BibliographyDetailVolumeTable'
import { Component, Prop, Watch, Ref, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base/ComponentVue.ts'
import { AlertCodeALC00007, BibliographyClass } from '@/types'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  BibliographyRealDetail,
  defaultBibliographyRealDetail,
  ErrorMessage,
  SystemCode
} from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import { Emit } from '@/node_modules/nuxt-property-decorator'
import { ModalMagazineVolumeEdit } from '@/components/modals/ModalMagazineVolumeEdit'
import ModalBookbindingCollections from '@/components/modals/ModalBookbindingCollections/ModalBookbindingCollections.vue'
import ModalBookbinding from '@/components/modals/ModalBookbinding/ModalBookbinding.vue'
import { BibliographyDetailVolumeTableDisplayBranchCode } from '@/components/organisms/BibliographyDetailVolumeTable/BibliographyDetailVolumeTable.vue'

@Component({
  components: {
    ModalBookbinding,
    ModalBookbindingCollections,
    ModalMagazineVolumeEdit,
    BibliographyDetailVolumeTable
  }
})
export default class BibliographyDetailSetVolumeList extends ComponentVue {
  @Ref()
  modalMagazineVolumeEdit!: ModalMagazineVolumeEdit

  @Ref()
  modalBookbindingCollections!: ModalBookbindingCollections

  @Ref()
  modalBookbinding!: ModalBookbinding

  @PropSync('tableItem', {
    type: Object,
    required: true
  })
  item!: BibliographyDetailVolumeTableItem

  @Prop({
    type: Number,
    required: true
  })
  bibliographySetId!: number

  @Prop({
    type: Object,
    required: true
  })
  searchType!: SystemCode

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Object,
    required: true
  })
  displayBranchCode!: BibliographyDetailVolumeTableDisplayBranchCode

  selectedBibliographyRealDetail: BibliographyRealDetail = defaultBibliographyRealDetail()

  get selectedVolume(): BibliographyDetailVolumeTableItemRow {
    return this.item.selectedRow()
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  @Watch('selectedVolume', { immediate: true, deep: true })
  onSelectedVolume() {
    if (this.item.selectedRow().bibliographyId > 0) {
      this.fetchBibliographyRealDetail()
    } else {
      this.selectedBibliographyRealDetail = defaultBibliographyRealDetail()
    }
  }

  onClickSimpleEdit(): void {
    this.modalMagazineVolumeEdit.open({
      bibliographyRealId: this.item.selectedRow().bibliographyId,
      onClickOk: () => {
        this.$emit('updated')
      }
    })
  }

  onClickRemove() {
    const alert = AlertFactory.create(AlertCodeALC00007, '書誌', '削除')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.deleteBibliographyRealCheck
    })
  }

  onClickEdit() {
    this.$modalBibliographyTagDataEdit.open({
      isEdit: true,
      editBibliographyId: this.item.selectedRow().bibliographyId,
      revision: this.item.selectedRow().revision,
      bibliographyClass: BibliographyClass.Real,
      searchType: this.searchType,
      details: this.selectedBibliographyRealDetail.details,
      onOk: () => {
        this.$emit('updated')
      }
    })
  }

  onClickNewVolume() {
    this.$modalBibliographyTagDataEdit.open({
      bibliographyClass: BibliographyClass.Real,
      searchType: this.searchType,
      bibliographySetId: this.bibliographySetId,
      onOk: () => {
        this.$emit('created')
      }
    })
  }

  onClickCopy() {
    const alert: Alert = AlertFactory.create(AlertCodeALC00007, '巻号', '複写')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.$modalBibliographyTagDataEdit.open({
          isCopy: true,
          bibliographyClass: BibliographyClass.Real,
          searchType: this.searchType,
          bibliographySetId: this.bibliographySetId,
          details: this.selectedBibliographyRealDetail.details,
          onOk: () => {
            this.$emit('created')
          }
        })
      }
    })
  }

  async fetchBibliographyRealDetail(): Promise<void> {
    try {
      this.selectedBibliographyRealDetail = await bibliographyRealApi.getBibliography(
        this.item.selectedRow().bibliographyId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async deleteBibliographyRealCheck(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const alerts = await bibliographyRealApi.deleteBibliographyRealCheck(
        this.item.selectedRow().bibliographyId
      )

      if (alerts.length > 0) {
        alertStore.setItems(alerts)
        this.$modalAlert.open({
          onOkClick: async () => {
            await this.deleteBibliographyReal()
          }
        })
      } else {
        await this.deleteBibliographyReal()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async deleteBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyRealApi.deleteBibliographyReal(
        this.item.selectedRow().bibliographyId
      )
      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onClickNextVolume() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyRealApi.createNextVolume(this.bibliographySetId)
      this.$emit('created')
    } catch (error) {
      if (error instanceof AlertMessage) {
        console.error(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickBookbinding(): void {
    this.modalBookbindingCollections.open({
      bibliographySetId: this.bibliographySetId,
      onClickOk: (collectionIds: number[]) => {
        this.modalBookbinding.open({
          collectionIds
        })
      }
    })
  }

  @Emit('link')
  onClickLink(bibliographyId: number): number {
    return bibliographyId
  }

  @Emit('volume')
  onClickVolume(bibliographyId: number): number {
    return bibliographyId
  }

  @Emit('toggle')
  onClickToggle(displayBranchCode: SystemCode): SystemCode {
    return displayBranchCode
  }

  @Emit('download')
  onClickDownload(): void {}
}
